export { globalObject } from './globalObject';
export type { GlobalObject } from './globalObject';
